<div class="dialog-overlay">
  <div class="dialog-content">
    <div class="modal-header">
      <div class="header-title">Save / Load Layouts</div>
      <button type="button" (click)="closeDialog()" class="close-button" aria-label="Close">
        <app-display-icon [colour]="iconColourEnum.black" [icon]="icons.close"></app-display-icon>
      </button>
    </div>

    <div class="content-container special-no-scroll">
      <div id="body-grid">
        <div class="saved-settings-h">
          <div class="orange-msg">
            <p>Save a new layout or select existing ones to load, replace, or copy.</p>
          </div>
        </div>

        <div class="saved-settings-h layouts-header-row">
          <div>Saved Layouts</div>
          @if (allowCopy) {
            <button
              type="button"
              class="select-all-button"
              (click)="toggleSelectAll()"
              [disabled]="getNumberOfSavedDocuments === 0">
              {{ allSelected ? 'Clear selection' : 'Select all' }}
            </button>
          }
        </div>

        <div class="special-scroller" id="saved-settings">
          @if (getNumberOfSavedDocuments) {
            @for (layout of savedLayouts; track layout.name) {
              <div
                (click)="selectExistingLayout(layout.name)"
                class="saved-layout-item"
                (dblclick)="confirmLoad(layout.name)"
                [class.selected]="newLayoutName === layout.name"
                [class.copy-selected]="isLayoutSelectedForCopy(layout.name)">
                <div class="saved-layout-item-details layout-name-cell">
                  @if (allowCopy) {
                    <input
                      type="checkbox"
                      class="layout-copy-checkbox"
                      [checked]="isLayoutSelectedForCopy(layout.name)"
                      (click)="onCopyCheckboxClick(layout.name, $event)"
                      [attr.aria-label]="'Select ' + layout.name + ' to copy'">
                  }
                  <span>{{ layout.name }}</span>
                </div>
                <div class="save-details saved-layout-item-details">
                  {{ getDisplayDate(layout) }}
                  @if (allowCopy) {
                    <button
                      type="button"
                      class="row-copy-button"
                      (click)="onCopySingleLayout(layout.name, $event)"
                      [attr.aria-label]="'Copy ' + layout.name">
                      <app-display-icon
                        [icon]="icons.contentCopy"
                        [tooltip]="'Copy this layout'">
                      </app-display-icon>
                    </button>
                  }
                  <button type="button" (click)="onDeleteLayout(layout.name, $event)"
                          [disabled]="newLayoutName !== layout.name"
                          aria-label="Delete layout">
                    <app-display-icon [icon]="icons.deleteOutline"></app-display-icon>
                  </button>
                </div>
              </div>
            }
          } @else {
            <div class="saved-layout-item">
              <div class="no-saves saved-layout-item-details">No Saved Layouts</div>
            </div>
          }
        </div>

        @if (hasClipboardLayouts) {
          <div class="clipboard-banner">
            <app-display-icon
              [icon]="icons.clipboardCheckOutline"
              [colour]="iconColourEnum.secondary">
            </app-display-icon>
            <span>{{ clipboardCount }} layout(s) ready to paste into this store.</span>
          </div>
        }

        <div class="actions-row">
          <div class="save-load-actions">
            <input [(ngModel)]="newLayoutName" placeholder="Enter a layout name">
            <button (click)="confirmSave()" [disabled]="!newLayoutName" type="button" aria-label="Save layout">
              <app-display-icon [icon]="icons.contentSaveOutline"></app-display-icon>
            </button>
            <app-shared-button (click)="confirmLoad(newLayoutName)" [disabled]="!selected" shape="circle">
              Load
            </app-shared-button>
          </div>

          <div class="copy-paste-actions">
            @if (allowCopy) {
              <app-shared-button
                [disabled]="!canCopy"
                (click)="onCopyLayouts()">
                <app-display-icon
                  [colour]="iconColourEnum.secondary"
                  [icon]="icons.contentCopy"
                  [tooltip]="'Copy selected layouts to paste into another store'">
                </app-display-icon>
                Copy selected
              </app-shared-button>
            } @else {
              <span class="copy-disabled-hint">Default layouts can’t be copied. Save to this store first.</span>
            }

            <app-shared-button
              [disabled]="!hasClipboardLayouts || isPasting"
              (click)="onPasteLayouts()">
              <app-display-icon
                [colour]="iconColourEnum.secondary"
                [icon]="icons.clipboardCheckOutline"
                [tooltip]="'Paste all copied layouts into this store (same name overwrites)'">
              </app-display-icon>
              {{ isPasting ? 'Pasting…' : 'Paste all' }}
            </app-shared-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
